module.exports = __webpack_public_path__ + "img/20180815_151629_189.7b8c03ae.jpg";